import { render, staticRenderFns } from "./UserInvestmentChoiceFeeAcknowledgementModal.vue?vue&type=template&id=9362da14&scoped=true"
import script from "./UserInvestmentChoiceFeeAcknowledgementModal.vue?vue&type=script&lang=ts"
export * from "./UserInvestmentChoiceFeeAcknowledgementModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9362da14",
  null
  
)

export default component.exports